import { DTOAccessory } from './DTOAccessory';
import { DTOAddressHistory } from './DTOAddressHistory';
import { DTODestination } from './DTODestination';
import { DTOException } from './DTOException';
import { DTOLiveRouteNow } from './DTOLiveRouteNow';
import { DTOParcelInfo } from './DTOParcelInfo';
import { DTOPhoto } from './DTOPhoto';
import { DTOSender } from './DTOSender';
import { DTOStop } from './DTOStop';
import { DTOStops } from './DTOStops';

export interface DTOShipment {
  /**
   * Nationex Customer Id (5 or 6 digits)
   */
  CustomerId: number;
  /**
   * Needs to be -1 for auto generation, 9 digits otherwise, used to identify and track the shipment
   */
  ShipmentId: number;
  /**
   * The expedition date
   */
  ExpeditionDate: string;
  /**
   * The quantity of parcels in the shipment. Cannot exceed 99.
   */
  TotalParcels: number;
  /**
   * Sum of weights of shipments (lbs)
   */
  TotalWeight: number;
  /**
   * Global status of the entire shipment
   */
  ShipmentStatus?: string;
  /**
   * Readable ShipmentStatus in french
   */
  ShipmentStatusFr?: string;
  /**
   * Readable ShipmentStatus in english
   */
  ShipmentStatusEn?: string;
  ShipmentType?: string;
  /**
   * Reference number, string which can be used to track the shipment
   */
  ReferenceNumber?: string;
  /**
   * A delivery driver note, this will be print on the label.
   */
  Note?: string;
  /**
   * Nationex Customer ID of the collect account if different from shipping account
   */
  BillingAccount?: number;
  Sender: DTOSender;
  Destination: DTODestination;
  Accessory: DTOAccessory;
  Parcels: Array<DTOParcelInfo>;
  ConsolShipmentIds?: Array<number>;
  /**
   * Id of the consolidated shipment. Corresponds to the lowest ShipmentId of the shipments going to the same address, same day
   */
  ConsolId?: number;
  /**
   * Signatures and photos. Linked with the PhotoId's and SignatureId's from DTOParcelHistory
   */
  Photos?: Array<DTOPhoto>;
  Stops?: DTOStops;
  AllowedExceptions?: Array<DTOException>;
  CustomerNote?: string;
  SellerName?: string;
  MainSACagentName?: string;
  SegmentFr?: string;
  SegmentEn?: string;
  StopHistory?: Array<DTOLiveRouteNow>;
  CustomerName?: string;
  IsInvoiced?: boolean;
  CurrentRouteFr?: string;
  CurrentRouteEn?: string;
  PickupStops?: DTOStops;
  IsReturnToShipper?: boolean;
  IsCustomerInactive?: boolean;
  IsConsolidated?: boolean;
  IsPickup?: boolean;
  SenderHistory?: Array<DTOAddressHistory>;
  DestinationHistory?: Array<DTOAddressHistory>;
}
export type ShipmentTypeEnum = 'Delivery' | 'PickupReturn' | 'PickupDelivery';
export const ShipmentTypeEnum = {
  Delivery: 'Delivery' as ShipmentTypeEnum,
  PickupReturn: 'PickupReturn' as ShipmentTypeEnum,
  PickupDelivery: 'PickupDelivery' as ShipmentTypeEnum
};
export type ShipmentStatusEnum =
  | 'Creation'
  | 'Pickup'
  | 'Transit'
  | 'OutForDelivery'
  | 'Delivered'
  | 'OnHold'
  | 'Attention'
  | 'Cancelled'
  | 'ReturnCompleted'
  | 'OutForPickup'
  | 'RefusedDelivery'
  | 'PartiallyPickedup'
  | 'PartiallyInTransit'
  | 'PartiallyOutForDelivery'
  | 'PartiallyDelivered'
  | 'ReturnToSender';
export const ShipmentStatusEnum = {
  Creation: 'Creation' as ShipmentStatusEnum,
  Pickup: 'Pickup' as ShipmentStatusEnum,
  Transit: 'Transit' as ShipmentStatusEnum,
  OutForDelivery: 'OutForDelivery' as ShipmentStatusEnum,
  Delivered: 'Delivered' as ShipmentStatusEnum,
  OnHold: 'OnHold' as ShipmentStatusEnum,
  Attention: 'Attention' as ShipmentStatusEnum,
  Cancelled: 'Cancelled' as ShipmentStatusEnum,
  ReturnCompleted: 'ReturnCompleted' as ShipmentStatusEnum,
  OutForPickup: 'OutForPickup' as ShipmentStatusEnum,
  RefusedDelivery: 'RefusedDelivery' as ShipmentStatusEnum,
  ReturnToSender: 'ReturnToSender' as ShipmentStatusEnum,
  PartiallyPickedUp: 'PartiallyPickedup' as ShipmentStatusEnum,
  PartiallyInTransit: 'PartiallyInTransit' as ShipmentStatusEnum,
  PartiallyOutForDelivery: 'PartiallyOutForDelivery' as ShipmentStatusEnum,
  PartiallyDelivered: 'PartiallyDelivered' as ShipmentStatusEnum
};
